<script setup lang="ts">
import { type IconName } from '../content/site-content';

/**
 * Le sei icone della sezione «cosa fa», disegnate a mano.
 *
 * Nessuna libreria: sono sei tracciati, e una dipendenza in più su un sito di
 * una pagina sola si paga a ogni build. Il tipo `IconName` tiene allineati
 * contenuto e disegni; il test del contenuto controlla che ogni nome citato
 * abbia qui il suo ramo.
 */
defineProps<{ name: IconName }>();
</script>

<template>
  <svg
    class="icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <!-- martelletto -->
    <template v-if="name === 'gavel'">
      <path d="m4.5 19.5 7-7" />
      <rect x="11" y="6.2" width="6.6" height="4.4" rx="1" transform="rotate(45 14.3 8.4)" />
      <path d="M14.5 15.5 19 20" />
      <path d="M3 21h6" />
    </template>

    <!-- saetta -->
    <template v-else-if="name === 'bolt'">
      <path d="M13 2 4.5 13.5H11l-1 8.5 9-12h-6.5z" />
    </template>

    <!-- foglio di calcolo -->
    <template v-else-if="name === 'sheet'">
      <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
      <path d="M3.5 9h17M9 9v11.5M3.5 15h17" />
    </template>

    <!-- telefono -->
    <template v-else-if="name === 'phone'">
      <rect x="6.5" y="2.5" width="11" height="19" rx="2.5" />
      <path d="M10.5 18.5h3" />
    </template>

    <!-- scudo -->
    <template v-else-if="name === 'shield'">
      <path d="M12 2.7 4.8 5.5v6c0 4.3 2.9 8.2 7.2 9.8 4.3-1.6 7.2-5.5 7.2-9.8v-6z" />
      <path d="m9 12 2.2 2.2L15.4 10" />
    </template>

    <!-- ritorno indietro -->
    <template v-else>
      <path d="M3.5 5.5v5h5" />
      <path d="M4.6 13a7.7 7.7 0 1 0 1.6-5.3" />
    </template>
  </svg>
</template>

<style scoped>
.icon {
  width: 1.5rem;
  height: 1.5rem;
  flex: none;
}
</style>
